import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoginShareServices {
  private objectSource = new BehaviorSubject<any>([]);
  currentObject = this.objectSource.asObservable();

  constructor() {}

  updateObject(showSideBar: any) {
    this.objectSource.next(showSideBar);
  }
}
